export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2OQ3D7vPwAEyQJuBx10vwAAAABJRU5ErkJggg=="